import HttpClient from '~/services/http-client'
import ApiRoutes from '~/services/api-routes.js'
import type { Place } from '~/types/place'

export const usePlacesStore = defineStore('placesStore', () => {
  const places = ref<Place[]>([])
  const place = ref<Place>()
  const isLoading = ref(false)

  // ─────────────────────────────────────────────
  // PLACES
  // ─────────────────────────────────────────────
  const fetchPlaces = async () => {
    isLoading.value = true
    const response = await HttpClient.get(ApiRoutes.RESERVATIONS_GET_PLACES)

    if (response.ok) {
      places.value = response.data
    }
    isLoading.value = false
  }

  const fetchPlace = async (placeId: number) => {
    const response = await HttpClient.get(
      ApiRoutes.RESERVATIONS_GET_PLACE(placeId)
    )
    if (response.ok) {
      place.value = response.data
    }
  }

  const createPlace = async (payload: Record<string, any>) => {
    isLoading.value = true
    const resp = await HttpClient.post(ApiRoutes.PLACES_POST, payload)
    isLoading.value = false
    return resp
  }

  const updatePlace = async (id: number, payload: Record<string, any>) => {
    isLoading.value = true
    const resp = await HttpClient.put(ApiRoutes.PLACES_PUT(id), payload)
    isLoading.value = false
    return resp
  }

  return {
    isLoading,
    place,
    places,
    fetchPlaces,
    fetchPlace,
    createPlace,
    updatePlace,
  }
})
